import React from 'react';

import { Fab } from '@mui/material';

import {
  CREDIT_TIER,
  CREDIT_TIER_FIELD_DISPLAY,
  SELECTED_TAB_STYLE,
} from '../../constants/Dashboard/Financing';

import './CreditTierTabs.css';

export const CreditTierTabs = ({ selectedCreditTier, handleSelectCreditTier }) => {
  return (
    <div className="auto-mortgage-credit-tier-wrapper">
      <p className="auto-mortgage-credit-tier-label">{CREDIT_TIER}</p>
      <div>
        {Object.keys(CREDIT_TIER_FIELD_DISPLAY).map((creditTierName) => {
          const additionalStyling = selectedCreditTier === creditTierName ? SELECTED_TAB_STYLE : {};
          return (
            <Fab
              key={creditTierName}
              sx={{
                '&:hover': { backgroundColor: 'white', color: 'black' },
                m: 1,
                color: 'black',
                textTransform: 'initial',
                backgroundColor: 'white',
                fontSize: 12,
                width: { xs: '28%', sm: '22%' },
                ...additionalStyling,
              }}
              variant="extended"
              size="large"
              onClick={() => handleSelectCreditTier(creditTierName)}
            >
              {creditTierName}
              <br />
              {CREDIT_TIER_FIELD_DISPLAY[creditTierName].score}
            </Fab>
          );
        })}
      </div>
    </div>
  );
};
